import {Tag, Tooltip} from "antd";
import {CheckCircleOutlined, CloseCircleOutlined, SyncOutlined, UploadOutlined} from "@ant-design/icons";
import React from "react";
import {useTranslation} from "react-i18next";

const TagDocumentStatus = ({status, tooltip}) => {
    const {t} = useTranslation()
    switch (status) {
        case 1: return <Tag icon={<SyncOutlined/>} color="default">{t('synchronized')}</Tag>
        case 2: return <Tag icon={<UploadOutlined />} color="processing">{t('uploaded')}</Tag>
        case 3: return <Tag icon={<CheckCircleOutlined/>} color="success">{t('success')}</Tag>
        case 4: if (tooltip) {
            return (
                <Tooltip title={tooltip}>
                    <Tag icon={<CloseCircleOutlined/>} color="error">{t('error')}</Tag>
                </Tooltip>
            )
        } else {
            return <Tag icon={<CloseCircleOutlined/>} color="error">{t('error')}</Tag>
        }
    }
}

export default TagDocumentStatus